<template>
  <div class="app page-sidebar-fixed page-header-fixed">
    <AppHeader/>
    <Sidebar :navItems="nav"/>
    <div id="content" class="content">
      <router-view></router-view>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items
    }
  },
  created: function() {
    /* add apropriate classes for body tag to support Admin theme */
    document.body.classList.add('app', 'header-fixed', 'sidebar-fixed', 'aside-menu-fixed', 'aside-menu-hidden')
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>







// WEBPACK FOOTER //
// src/admin/containers/Full.vue